import { render, staticRenderFns } from "./TipoAfectacion.vue?vue&type=template&id=67dda57f"
import script from "./TipoAfectacion.vue?vue&type=script&lang=ts"
export * from "./TipoAfectacion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports